import { AppSettings } from '@model/app-settings';
import { createAction, props } from '@ngrx/store';
import { CustomerType } from 'src/app/model/customer';
import { Advertisment, CommunicationMechanism, Menu, OnlineReservationCategory } from 'src/app/model/login-response.dto';
import { ReservationTagCategory } from 'src/app/model/reservation-tag';
import { Source } from 'src/app/model/source';
import { TagDTO } from 'src/app/model/tags.dto';

export const loadApps = createAction(
  '[App] Load Apps'
);

export const loadAppsSuccess = createAction(
  '[App] Load Apps Success',
  props<{ data: any }>()
);

export const loadAppsFailure = createAction(
  '[App] Load Apps Failure',
  props<{ error: any }>()
);

export const setMenus = createAction(
  '[App] Set Menus',
  props<{ menus: Menu[] }>()
);

export const setOnlineCategories = createAction(
  '[App] Set Online Categories',
  props<{ onlineCategories: OnlineReservationCategory[] }>()
);

export const setCustomerTypes = createAction(
  '[App] Set Customer Types',
  props<{ customerTypes: CustomerType[] }>()
);

export const loadSources = createAction(
  '[App] Load Sources'
);

export const loadSourcesSuccess = createAction(
  '[App] Load Sources Success',
  props<{ sources: Source[] }>()
);

export const loadSourcesFailure = createAction(
  '[App] Load Sources Failure',
  props<{ error: any }>()
);

export const updateSource = createAction(
  '[App] Update Source',
  props<{ source: Source }>()
);

export const loadTags = createAction(
  '[App] Load Tags'
);

export const loadTagsSuccess = createAction(
  '[App] Load Tags Success',
  props<{ tags: ReservationTagCategory[] | null }>()
);

export const loadTagsFailure = createAction(
  '[App] Load Tags Failure',
  props<{ error: any }>()
);

export const setRestaurantId = createAction(
  '[App] Set Restaurant Id',
  props<{ restaurantId: number }>()
);

export const setRestaurantName = createAction(
  '[App] Set Restaurant Name',
  props<{ restaurantName: string }>()
);

export const setIsOffline = createAction(
  '[App] Set Is Offline',
  props<{ isOffline: boolean }>()
);

export const showAlert = createAction(
  '[App] Show Alert',
  props<{ alert: string }>()
);

export const hideAlert = createAction(
  '[App] Hide Alert'
);

export const setCommunication = createAction(
  '[App] Set Communication',
  props<{ communication: CommunicationMechanism }>()
);

export const logout = createAction(
  '[App] Logout'
);

export const setServiceStopDate = createAction(
  '[App] Set Service Stop Date',
  props<{ stopDate: Date }>()
);

export const setExtraStatuses = createAction(
  '[App] Set Extra Statuses',
  props<{ extraStatuses: string[] }>()
);

export const setMinTelephoneLength = createAction(
  '[App] Set Min Telephone Length',
  props<{ minTelephoneLength: number }>()
);

export const setQueueHttpRequests = createAction(
  '[App] Set Queue Http Requests',
  props<{ value: boolean }>()
);

export const setAds = createAction(
  '[App] Set Ads',
  props<{ ads: Advertisment }>()
);

export const checkForAdvertisment = createAction(
  '[App] Check For Advertisment'
);

export const help = createAction(
  '[App] Help'
);

export const loadAppSettings = createAction(
  '[App] Load App Settings'
);

export const setAppSettings = createAction(
  '[App] Set App Settings',
  props<{ appSettings: AppSettings }>()
);

export const setEditingAppSettings = createAction(
  '[App] Set Editing App Settings',
  props<{ appSettings: AppSettings }>()
);

export const saveEditingAppSettings = createAction(
  '[App] Save App Settings'
);

export const showToast = createAction(
  '[App] Show Toast',
  props<{ message: string | null }>()
);

export const setRestaurants = createAction(
  '[App] Set Restaurants',
  props<{ restaurants: { display: string, value: string }[] }>()
);

export const emptyAction = createAction(
  '[App] Empty Action'
);
